/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Archived_ToastInputs */

const en_branches_archived_toast = /** @type {(inputs: Branches_Archived_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch archived`)
};

const pt_br2_branches_archived_toast = /** @type {(inputs: Branches_Archived_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filial arquivada`)
};

/**
* | output |
* | --- |
* | "Branch archived" |
*
* @param {Branches_Archived_ToastInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_archived_toast = /** @type {((inputs?: Branches_Archived_ToastInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Archived_ToastInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_archived_toast(inputs)
	return pt_br2_branches_archived_toast(inputs)
});